export default __webpack_public_path__ + "media/src/assets/images/MapPinCrossDockDelivery-dcbc9ec710395fda230e45ef6d1eae56.svg";